module.exports = __webpack_public_path__ + "static/media/downloadGCSButton.deb48ad1.svg";